// extracted by css-extract-rspack-plugin
export default {"quantityInputChirpWrapper":"quantityInputChirpWrapper-lztXFI","selectChirp":"selectChirp-Jv6D4v"};